import { Stack } from "@mui/material";
import { FeedbackFile } from "../../types/apiTypes";

export const FeedbackImages = ({
  image_previews,
  setImageIdx,
}: {
  image_previews: FeedbackFile[];
  setImageIdx: (i: number | null) => void;
}) => {
  return (
    <Stack direction="row" flexWrap="wrap" gap="8px" alignItems="center">
      {image_previews.map(({ filename, url }, index) => (
        <Stack
          onClick={() => setImageIdx(index)}
          key={url}
          alignItems="center"
          justifyContent="center"
          style={{
            height: "100%",
            maxHeight: "90px",
            cursor: "pointer",
          }}
        >
          <img
            src={url}
            alt={`media-${filename}`}
            style={{
              maxHeight: "90px",
              objectFit: "contain",
            }}
          />
        </Stack>
      ))}
    </Stack>
  );
};
